<template>
  <v-app style="background-color: transparent;">
    <AppBar/>
    <v-alert
      v-model="alert"
      class="notify"
      dark
    >
      <v-row align="center">
        <v-col>{{$t('cookie_notify')}}</v-col>
        <v-btn class="mr-4" @click="closeCookieNotify()">Accept Cookies</v-btn>
        <v-btn icon class="mr-4" @click="closeCookieNotify()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-alert>
    <router-view></router-view>
  </v-app>
</template>

<script>
  import AppBar from './components/AppBar';

  export default {
    name: 'App',
    components: {
      // Home,
      AppBar,
    },
    mounted() {
      if (!this.$cookies.get('cookies_notify')) {
        this.alert = true
      }
      this.$ga.page('reddle_website');
    },
    methods: {
      closeCookieNotify() {
        this.$cookies.set('cookies_notify', false)
        this.alert = false
      }
    },
    data: () => ({
      alert: false
    }),
  };
</script>
<style scoped>
  .notify {
    position: fixed;
    width: 100%;
    z-index: 900;
    background-color: rgba(77, 74, 74, 0.6);
    bottom: 0;
    left: 0
  }
</style>
